__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/8f2142c/packs/";